const filterSelect = $(".downloadList__filterSelect");
const urlParams = new URLSearchParams(window.location.search);
const searchValue = urlParams.get("search");

if (searchValue && searchValue != "all") {
  filterSelect.val(searchValue);
  setTimeout(function () {
    filterSelect.trigger("change");
  }, 10);
}

$(".downloadList__radio, .downloadList__filterSelect").on(
  "change",
  function () {
    const selectedValue = $(this).val();
    // 片方が変更された場合、もう一方を自動的に状態を変更させる
    if ($(this).hasClass("downloadList__radio")) {
      filterSelect.val(selectedValue);
    } else {
      $(".downloadList__radio")
        .filter("[value='" + selectedValue + "']")
        .prop("checked", true);
    }

    selectedValueClass = selectedValue != "all" ? "." + selectedValue : "";

    // 一覧アイテムのフィルター処理
    $(".downloadList__article").hide();
    $(".downloadList__article" + selectedValueClass).fadeIn();

    // urlのパラメータ更新
    if (urlParams.has("search")) {
      urlParams.set("search", selectedValue);
    } else {
      urlParams.append("search", selectedValue);
    }
    history.replaceState(
      null,
      "",
      window.location.pathname + "?" + urlParams.toString()
    );

    updateLanguageParam();
  }
);
